"use client";

import { Button } from "@ui/components/button";
import { Input } from "@ui/components/input";
import { Label } from "@ui/components/label";
import { Textarea } from "@ui/components/textarea";
import { SubmitHandler, useForm } from "react-hook-form";
import { ContactFormValues } from "./props";
import { zodResolver } from "@hookform/resolvers/zod";
import { ContactSchema } from "./schema";
import { maskPhone } from "../../../utils/common";
import { useSendContactEmail } from "../../../hooks/api/contact";
import posthog from "posthog-js";

export const ClickAutosContactForm = () => {
  const { loading, sendContactEmail } = useSendContactEmail();
  const {
    reset,
    setValue,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ContactFormValues>({
    criteriaMode: "firstError",
    reValidateMode: "onChange",
    resolver: zodResolver(ContactSchema),
  });

  const onSubmit: SubmitHandler<ContactFormValues> = async (data) => {
    await sendContactEmail(data);
    posthog.identify(data.email, { ...data });
    posthog.capture("Formulário de Contato", { ...data });
    reset();
  };

  return (
    <form
      className="space-y-5 w-full md:max-w-[50%] mx-auto"
      onSubmit={handleSubmit(onSubmit)}
    >
      <div className="flex gap-5 flex-col sm:flex-row">
        <div className="w-full relative">
          <Label>Nome</Label>
          <Input
            type="text"
            placeholder="Seu nome"
            {...register("firstName")}
          />
          {errors.firstName && (
            <span className="text-xs text-red-500 absolute -bottom-4 left-1">
              {errors.firstName.message}
            </span>
          )}
        </div>
        <div className="w-full relative">
          <Label>Sobrenome</Label>
          <Input
            type="text"
            placeholder="Seu Sobrenome"
            {...register("lastName")}
          />
          {errors.lastName && (
            <span className="text-xs text-red-500 absolute -bottom-4 left-1">
              {errors.lastName.message}
            </span>
          )}
        </div>
      </div>
      <div className="flex flex-col md:flex-row gap-5">
        <div className="w-full relative">
          <Label>Email</Label>
          <Input type="text" placeholder="Seu email" {...register("email")} />
          {errors.email && (
            <span className="text-xs text-red-500 absolute -bottom-4 left-1">
              {errors.email.message}
            </span>
          )}
        </div>
        <div className="w-full relative">
          <Label>Telefone</Label>
          <Input
            type="text"
            placeholder="Seu telefone"
            {...register("phone", {
              onChange: (e) => {
                const maskedValue = maskPhone(e.target.value);
                setValue("phone", maskedValue);
              },
            })}
            maxLength={15}
          />
          {errors.phone && (
            <span className="text-xs text-red-500 absolute -bottom-4 left-1">
              {errors.phone.message}
            </span>
          )}
        </div>
      </div>
      <div className="w-full relative">
        <Label>Mensagem</Label>
        <Textarea
          rows={8}
          className="resize-none mt-1"
          {...register("message")}
        />
        {errors.message && (
          <span className="text-xs text-red-500 absolute -bottom-4 left-1">
            {errors.message.message}
          </span>
        )}
      </div>
      <div>
        <Button disabled={loading} variant="default" type="submit">
          Enviar Mensagem
        </Button>
      </div>
    </form>
  );
};
